import { z } from 'zod/v4';

export const BALANCE_ROW_TYPE = ['invoice', 'credit_note', 'payment'] as const;

export type BalanceRowType = (typeof BALANCE_ROW_TYPE)[number];

export const BalanceRowTypeSchema = z.enum([...BALANCE_ROW_TYPE]);
